import type * as lazyIndex from './lazyIndex';
import type { NeedsReplyItemFeedbackProps } from './components/NeedsReplyItemFeedback';
import type { NeedsReplyViewHeaderButtonsProps } from './components/NeedsReplyViewHeaderButtons';
import {
    createLazyComponent,
    type LazyComponent,
    LazyAction,
    LazyModule,
    registerLazyOrchestrator,
} from 'owa-bundling';
import { needsReplyCountRefreshRequested } from 'owa-mail-reply-nudge-store';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailNeedsReply"*/ './lazyIndex'),
    { name: 'MailNeedsReply' }
);

export const NeedsReplyBar: LazyComponent<unknown, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.NeedsReplyBar
);

export const NeedsReplyItemFeedback: LazyComponent<NeedsReplyItemFeedbackProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.NeedsReplyItemFeedback);

export const NeedsReplyViewHeaderButtons: LazyComponent<
    NeedsReplyViewHeaderButtonsProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.NeedsReplyViewHeaderButtons);

export const lazyOpenNeedsReplyView: LazyAction<
    typeof lazyIndex.openNeedsReplyView,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openNeedsReplyView);

export const lazyReloadNeedsReplyView: LazyAction<
    typeof lazyIndex.reloadNeedsReplyView,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.reloadNeedsReplyView);

export const lazyFetchNeedsReplyCount: LazyAction<
    typeof lazyIndex.fetchNeedsReplyCount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.fetchNeedsReplyCount);

registerLazyOrchestrator(
    needsReplyCountRefreshRequested,
    lazyModule,
    m => m.needsReplyCountRefreshOrchestrator
);
